import Vue from 'vue';
import Vuex from 'vuex';
import persistData from '@/util/plugins/persist-data';
import banners from './modules/banners';
import brandBuilderEditor from './modules/brand-builder-editor';
import bbSelectRecipientModal from './modules/bb-select-recipient-modal';
import clientConnectV2 from './modules/client-connect-v2';
import ccContacts from './modules/cc-contacts';
import companyProfile from './modules/company-profile';
import complianceLogos from './modules/compliance-logos';
import dripCampaigns from './modules/drip-campaigns';
import globalErrors from './modules/global-errors';
import globalLoading from './modules/global-loading';
import lendwizePricingScenario from './modules/pricing-scenarios';
import licenses from './modules/legal-licenses';
import marketingResources from './modules/marketing-resources';
import menus from './modules/menus';
import partners from './modules/preference-center-partners';
import preferenceCenterHome from './modules/preference-center-home';
import preferenceCenterPermissions from './modules/preference-center-permissions';
import preferenceCenterFamb from './modules/preference-center-famb';
import profile from './modules/user-profile';
import profileSwitcher from './modules/profile-switcher';
import search from './modules/search';
import userAlerts from './modules/user-alerts';
import workspaceBranding from './modules/workspace-branding';

Vue.use(Vuex);

export default new Vuex.Store({
	modules: {
		banners,
		brandBuilderEditor,
		bbSelectRecipientModal,
		clientConnectV2,
		ccContacts,
		companyProfile,
		complianceLogos,
		dripCampaigns,
		globalErrors,
		globalLoading,
		lendwizePricingScenario,
		licenses,
		marketingResources,
		menus,
		partners,
		preferenceCenterHome,
		preferenceCenterPermissions,
		preferenceCenterFamb,
		profile,
		profileSwitcher,
		search,
		userAlerts,
		workspaceBranding,
	},
	plugins: [persistData],
});
